/*
|--------------------------------------------------------------------------
| PLATFORM STORAGE KEYS
|--------------------------------------------------------------------------
*/

const PLATFORM_ACCESS_TOKEN_KEY =
    "platformAccessToken";

const PLATFORM_REFRESH_TOKEN_KEY =
    "platformRefreshToken";

const PLATFORM_USER_KEY =
    "platformUser";


/*
|--------------------------------------------------------------------------
| SAVE ACCESS TOKEN
|--------------------------------------------------------------------------
*/

export const savePlatformToken = (
    token
) => {

    if (
        typeof window ===
        "undefined"
    ) {
        return;
    }

    if (
        !token
    ) {
        localStorage.removeItem(
            PLATFORM_ACCESS_TOKEN_KEY
        );

        return;
    }

    localStorage.setItem(
        PLATFORM_ACCESS_TOKEN_KEY,
        token
    );

};


/*
|--------------------------------------------------------------------------
| GET ACCESS TOKEN
|--------------------------------------------------------------------------
*/

export const getPlatformToken =
    () => {

        if (
            typeof window ===
            "undefined"
        ) {
            return null;
        }

        return (
            localStorage.getItem(
                PLATFORM_ACCESS_TOKEN_KEY
            ) ||
            null
        );

    };


/*
|--------------------------------------------------------------------------
| SAVE REFRESH TOKEN
|--------------------------------------------------------------------------
*/

export const savePlatformRefreshToken = (
    token
) => {

    if (
        typeof window ===
        "undefined"
    ) {
        return;
    }

    if (
        !token
    ) {

        localStorage.removeItem(
            PLATFORM_REFRESH_TOKEN_KEY
        );

        return;

    }

    localStorage.setItem(
        PLATFORM_REFRESH_TOKEN_KEY,
        token
    );

};


/*
|--------------------------------------------------------------------------
| GET REFRESH TOKEN
|--------------------------------------------------------------------------
*/

export const getPlatformRefreshToken =
    () => {

        if (
            typeof window ===
            "undefined"
        ) {
            return null;
        }

        return (
            localStorage.getItem(
                PLATFORM_REFRESH_TOKEN_KEY
            ) ||
            null
        );

    };


/*
|--------------------------------------------------------------------------
| SAVE USER
|--------------------------------------------------------------------------
*/

export const savePlatformUser = (
    user
) => {

    if (
        typeof window ===
        "undefined"
    ) {
        return;
    }

    if (
        !user
    ) {

        localStorage.removeItem(
            PLATFORM_USER_KEY
        );

        return;

    }

    localStorage.setItem(
        PLATFORM_USER_KEY,
        JSON.stringify(
            user
        )
    );

};


/*
|--------------------------------------------------------------------------
| GET USER
|--------------------------------------------------------------------------
*/

export const getPlatformUser =
    () => {

        if (
            typeof window ===
            "undefined"
        ) {
            return null;
        }

        try {

            const value =
                localStorage.getItem(
                    PLATFORM_USER_KEY
                );

            if (
                !value
            ) {
                return null;
            }

            return JSON.parse(
                value
            );

        } catch (
            error
        ) {

            console.error(
                "Unable to read platform user:",
                error
            );

            return null;

        }

    };


/*
|--------------------------------------------------------------------------
| CLEAR PLATFORM AUTH
|--------------------------------------------------------------------------
*/

export const clearPlatformAuthStorage =
    () => {

        if (
            typeof window ===
            "undefined"
        ) {
            return;
        }

        localStorage.removeItem(
            PLATFORM_ACCESS_TOKEN_KEY
        );

        localStorage.removeItem(
            PLATFORM_REFRESH_TOKEN_KEY
        );

        localStorage.removeItem(
            PLATFORM_USER_KEY
        );

    };